import React from 'react';

import {useAccessWrapper} from './useAccessWrapper';
import {NoAccessComponent} from './noAccessComponent';
import {AccessWrapperProps} from './types';

export function AccessWrapper({
  headerList,
  nonProtectedRoutes,
  noAccessHeading,
  noAccessDesc,
  children
}: AccessWrapperProps) {
  const {isAccess} = useAccessWrapper(nonProtectedRoutes, [...headerList]);
  if (!isAccess) {
    return <NoAccessComponent noAccessHeading={noAccessHeading} noAccessDesc={noAccessDesc} />;
  }

  return <div>{children}</div>;
}
